import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { CHANGELOG_ENTRIES } from "../../content/changelog";
import useLocalStorage from "../../hooks/useLocalStorage";
import Logo from "./Logo";
import MobileNavigation from "./MobileNavigation";
import Navigation from "./Navigation";
import UserSection from "./UserSection";

const Header = () => {
  const location = useLocation();
  const [lastSeenEntryId, setLastSeenEntryId] = useLocalStorage<string>("bloodline.whats-new.last-seen", "");
  const latestEntryId = CHANGELOG_ENTRIES[0]?.id ?? "";
  const hasUnreadNews = latestEntryId !== "" && lastSeenEntryId !== latestEntryId;

  useEffect(() => {
    if (location.pathname === "/whats-new" && latestEntryId !== "") {
      setLastSeenEntryId(latestEntryId);
    }
  }, [latestEntryId, location.pathname, setLastSeenEntryId]);

  return (
    <header className="flex items-center justify-between sticky top-0 z-20 h-20 px-4 bg-white drop-shadow">
      <div className="flex items-center gap-4 shrink-0">
        <MobileNavigation hasUnreadNews={hasUnreadNews} />
        <Logo />
      </div>
      <Navigation hasUnreadNews={hasUnreadNews} />
      <UserSection />
    </header>
  );
};

export default Header;
